import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Grid, Typography} from '@mui/material';

import {ColumnDefinition, CulturalDashboardTable} from '../culture/dashboard/components/shared/CulturalDashboardTable';

import {bodyPdf, pdfH1} from './styles';
import {CultureAnalysisPdfContext} from '../../../contexts/CultureAnalysisPdfContext/CultureAnalysisPdfContext';
import {LanguageContext} from '../../../contexts/LanguageContext/LanguageContext';
import {empionOrangeGradient} from '../../../layouts/theme/designSystem';
import {AllStrengths} from '../../company/culture/dashboard/types/CompanyStrengthsTypes';

export const Strengths = () => {
  const {t} = useTranslation('pdfDomain');
  const {t: strengthT} = useTranslation();
  const currentLanguage = useContext(LanguageContext);

  const {data, loading} = useContext(CultureAnalysisPdfContext);

  if (loading || !data) {
    return null;
  }

  const strengths = data.strengths;
  const orderedStrengths = strengths.all.sort((a, b) => b.percentage - a.percentage);

  const strengthsColumns: ColumnDefinition<AllStrengths>[] = [
    {
      key: 'label',
      label: strengthT('companyCultureDashboard.strengths.tableHeadTile'),
      render: (item) => item.label[currentLanguage],
    },
    {
      key: 'distribution',
      label: '#',
      render: (item) => item.distribution,
    },
    {
      key: 'percentage',
      label: '%',
      render: (item) => `${Math.round(item.percentage * 100)}%`,
    },
  ];

  return (
    <>
      <Grid container sx={{background: empionOrangeGradient.dark}} height={'190px'} p={5}>
        <Box width={'560px'}>
          <Typography variant='h1' sx={pdfH1} mb={3}>
            {t('strengths.title')}
          </Typography>
          <Typography sx={bodyPdf} mb={1}>
            {t('strengths.textBlock')}
          </Typography>
        </Box>
      </Grid>
      <Grid container px={5} mt={-2}>
        <CulturalDashboardTable
          data={orderedStrengths}
          columns={strengthsColumns}
          alternativeTitle={t('strengths.alternativeTitle') as string}
          textStyleHeaders={{fontSize: '18px'}}
          textStyleBody={bodyPdf}
        />
        <Grid item container justifyContent={'end'} mt={1}>
          <Typography sx={bodyPdf} mb={1}>
            {t('strengths.asterisk')}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};
